import Reminders from './reminders';

export default Reminders;
